import { render } from "./MarkupPage.vue?vue&type=template&id=6db28591&scoped=true"
import script from "./MarkupPage.vue?vue&type=script&lang=js"
export * from "./MarkupPage.vue?vue&type=script&lang=js"

import "./MarkupPage.vue?vue&type=style&index=0&id=6db28591&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6db28591"

export default script